import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Animal, Listing } from 'shared/@types';
import type { BaseModalProps } from 'shared/components/base-modal';
import { FullscreenModal } from 'shared/components/fullscreen-modal';
import PetInsuranceCalculator from 'shared/components/pet-insurance-calculator';
import type { InsuranceCalculatorStep } from 'shared/library/pet-insurance-calculator';

export function PetInsurancePriceModal({
  listing,
  animal = Animal.Dog,
  trigger,
}: {
  listing?: Listing;
  animal?: Animal;
  trigger: BaseModalProps['trigger'];
}) {
  const { t } = useTranslation('components');
  const [step, setStep] = useState<InsuranceCalculatorStep>('details');
  const [submitting, setSubmitting] = useState(false);

  return (
    <FullscreenModal
      headerTitle={t(
        step === 'call' ? 'pet_insurance_calculator.book_call' : 'pet_insurance_calculator.title',
      )}
      description={step === 'details' ? t('pet_insurance_calculator.owner_intro') : undefined}
      centered={true}
      className={'md:h-[min(52rem,96dvh)]'}
      contentTestID={'insurance-price-modal'}
      scrollable={false}
      closeDisabled={submitting}
      trigger={(modal) =>
        trigger?.({
          ...modal,
          open: () => {
            setStep('details');
            modal.open();
          },
        })
      }
    >
      <PetInsuranceCalculator
        listing={listing}
        animal={listing?.animal ?? animal}
        step={step}
        onStepChange={setStep}
        onSubmittingChange={setSubmitting}
      />
    </FullscreenModal>
  );
}
